import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Checkbox } from "../../components/ui/checkbox";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";

export default function AdminTasks() {
  const [tasks, setTasks] = useState([]);

  async function load() {
    const r = await api.get("/admin/tasks");
    setTasks(r.data);
  }
  useEffect(() => { load(); }, []);

  async function updateStatus(id, status) {
    await api.patch(`/admin/tasks/${id}`, { status });
    toast.success("Tarefa atualizada");
    load();
  }

  async function toggleChecklist(task, idx) {
    const cl = [...task.checklist];
    cl[idx].done = !cl[idx].done;
    await api.patch(`/admin/tasks/${task.id}`, { checklist: cl });
    setTasks(tasks.map((t) => (t.id === task.id ? { ...t, checklist: cl } : t)));
  }

  return (
    <div data-testid="admin-tasks-page">
      <div className="mb-8">
        <span className="text-[11px] uppercase tracking-[0.28em] text-slate-500">Operação</span>
        <h1 className="text-3xl font-semibold text-[#0AA89C] mt-1">Tarefas de operação</h1>
      </div>

      <div className="space-y-4">
        {tasks.length === 0 && (
          <div className="bg-white border border-slate-200 rounded-md p-12 text-center text-slate-500">
            Nenhuma tarefa ainda. Elas são criadas automaticamente ao confirmar reservas.
          </div>
        )}
        {tasks.map((t) => (
          <div key={t.id} className="bg-white border border-slate-200 rounded-md p-5" data-testid={`task-${t.id}`}>
            <div className="flex items-start justify-between gap-4">
              <div>
                <div className="font-medium">{t.title}</div>
                <div className="text-xs text-slate-500 mt-1">
                  {t.house_name} · Vencimento {t.due_date || "—"} · {t.kind}
                </div>
              </div>
              <Select value={t.status} onValueChange={(v) => updateStatus(t.id, v)}>
                <SelectTrigger className="w-40" data-testid={`task-status-${t.id}`}><SelectValue /></SelectTrigger>
                <SelectContent className="bg-white">
                  <SelectItem value="pending">Pendente</SelectItem>
                  <SelectItem value="in_progress">Em andamento</SelectItem>
                  <SelectItem value="done">Concluída</SelectItem>
                </SelectContent>
              </Select>
            </div>
            {t.checklist?.length > 0 && (
              <ul className="mt-4 space-y-2">
                {t.checklist.map((c, i) => (
                  <li key={i} className="flex items-center gap-2 text-sm">
                    <Checkbox checked={c.done} onCheckedChange={() => toggleChecklist(t, i)} />
                    <span className={c.done ? "line-through text-slate-400" : ""}>{c.item}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
